import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import { findObjectUseCase, upsertUseCase } from "../../../usecases/object";
import { Button } from "nq-component";
import InputFactory from "../../../components/InputFactory";
class AccessPINPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = { objects: [], isLoading: false };
  }

  async componentDidMount() {
    await this.fetchObject();
  }

  async fetchObject() {
    const objects = await findObjectUseCase().execute(
      this.getCollectionName(),
      { where: {}, sort: { created: -1 } },
    );
    this.setState({ objects });
  }

  getCollectionName() {
    return "access_pin";
  }
  async generateAccessPIN(object) {
    this.setState({ isLoading: true });
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    let pin = "";
    for (let i = 0; i < 16; i++) {
      pin += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    console.log("Generated PIN:", pin);
    try {
      object.accessPass = pin;
      await upsertUseCase().execute(this.getCollectionName(), object);
      await this.fetchObject();
    } catch (e) {
      console.error(e.message || e);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  async copyAccess(accessPass) {
    try {
      await navigator.clipboard.writeText(accessPass);
      this.showSuccess("Access PIN copied to clipboard");
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  }

  render() {
    const { objects, isLoading } = this.state;
    console.log("objects: ", objects);
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    return (
      <>
        <div className="overflow-auto mt-5 p-4">
          <div
            className="d-flex mt-4 mb-4"
            style={{ borderBottom: "1.5px solid #d3d3d3" }}
          >
            <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
              You are here: Home {">"} System Administration {">"}{" "}
              <span style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}>
                Access PIN
              </span>
            </p>
          </div>
          <div className="h-100 d-grid gap-2">
            <div className="w-50">
              {objects.map((object) => {
                return (
                  <InputFactory
                    type="Password"
                    // defaultValue={filteredObject[0]?.assignedEmployee}
                    value={object.accessPass}
                    onChange={() => {}}
                    field="accessPass"
                  />
                );
              })}
            </div>
            {objects.length > 0 && (
              <div className="d-flex gap-3">
                <Button
                  progress={isLoading}
                  className="btn btn-outline-light fs-sm text-primary border-primary"
                  onClick={() => this.copyAccess(objects[0].accessPass)}
                >
                  Copy
                </Button>
                <Button
                  progress={isLoading}
                  className="btn btn-primary fs-sm"
                  onClick={() => this.generateAccessPIN(objects[0])}
                >
                  Generate
                </Button>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(AccessPINPage);
